export default process.env.NODE_ENV === 'development' ? '' : '/destiny-child-mods-archive'